const locationEn = {
  selector: {
    districtLabel: 'District',
    upazillaLabel: 'Upazila',
    bazarLabel: 'Bazar',
    districtSearchPlaceholder: 'Search district...',
    upazillaSearchPlaceholder: 'Search upazila...',
    bazarSearchPlaceholder: 'Search bazar...'
  },
  popup: {
    title: 'Select Your Area',
    instruction: 'Choose your district, upazila and bazar to use Grameen Bazar',
    chooseDistrict: 'Select District',
    chooseUpazilla: 'Select Upazila',
    chooseBazar: 'Select Bazar',
    districtSearchPlaceholder: 'Search district...',
    upazillaSearchPlaceholder: 'Search upazila...',
    bazarSearchPlaceholder: 'Search bazar...',
    selectedPrefix: 'Selected:',
    confirm: 'Confirm'
  }
};

export default locationEn;


